import React from 'react'
import styled from 'styled-components'
import { Link } from 'gatsby'
import KpoLogo from '../kpoLogo'

const KpoInfoBar = () => (
  <StyledKpoInfoBar className="element-dark">
    {/* hardcoded link to kpo document */}
    <Link to="/dokumenty/kpo">
      <KpoLogo className="kpoLogoImg" alt="Krajowy Plan Odbudowy" />
    </Link>
  </StyledKpoInfoBar>
)

const StyledKpoInfoBar = styled.div`
  background-color: var(--backgroundMain);
  height: 5rem;

  position: relative;
  margin: 0.2rem auto;

  width: 100%;
  max-width: 800px;

  transition: transform 0.3s ease-out;

  .kpoLogoImg {
    max-height: 100%;
  }
`

export default KpoInfoBar
